module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig06_profile-deviation-profile-crown.525b725a.png";